import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {TicketAttachment} from '../../../model/Ticket';
import {TicketsService} from '../../../services/tickets.service';

import {RouterLink} from "@angular/router";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-attachment-downloader',
    templateUrl: './attachment-downloader.component.html',
    imports: [
    RouterLink,
    FaIconComponent
],
    styleUrls: ['./attachment-downloader.component.css']
})
export class AttachmentDownloaderComponent {

  @Input() attachment: TicketAttachment;
  @Input() ticketId: string;
  @ViewChild('blob') blob: ElementRef;

  constructor(private ticketService: TicketsService) {
  }

  downloadAttachment(attachment: TicketAttachment): void {
    this.ticketService.downloadAttachment(this.ticketId, this.attachment.link).subscribe(value => {
      const url = window.URL.createObjectURL(value);
      this.blob.nativeElement.setAttribute('href', url);
      this.blob.nativeElement.setAttribute('download', attachment.filename);
      this.blob.nativeElement.click();
      window.URL.revokeObjectURL(url);
    });
  }

}
